module.exports = __webpack_public_path__ + "img/norealName.2e6bc88b.png";